"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _formatPipelines = _interopRequireDefault(require("reference-resolvers/formatters/formatPipelines"));

var _immutable = require("immutable");

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var getDisplayOrder = function getDisplayOrder(stage) {
  if (typeof stage.get('displayOrder') === 'number') {
    return stage.get('displayOrder');
  } else {
    return -1;
  }
};

var formatStageId = function formatStageId(stage) {
  return String(stage.get('stageId'));
};

var formatStageReference = function formatStageReference(pipelineCount, pipelineRef, stage) {
  return new _ReferenceRecord.default({
    id: formatStageId(stage),
    label: pipelineCount > 1 ? stage.get('label') + " (" + pipelineRef.label + ")" : stage.get('label'),
    referencedObject: stage.merge({
      pipeline: pipelineRef.referencedObject
    })
  });
};

var getPipelineRefStages = function getPipelineRefStages(pipelineCount, pipelineRef) {
  var sortedStages = pipelineRef.getIn(['referencedObject', 'stages']).sortBy(getDisplayOrder);
  return (0, _immutable.OrderedMap)(sortedStages.map(function (stage) {
    return [formatStageId(stage), formatStageReference(pipelineCount, pipelineRef, stage)];
  }));
};

var formatPipelineStages = function formatPipelineStages(response) {
  var pipelineRefs = (0, _formatPipelines.default)(response);
  var pipelineCount = pipelineRefs.size;
  return pipelineRefs.valueSeq().map((0, _partial.default)(getPipelineRefStages, pipelineCount)).reduce(function (a, b) {
    return a.merge(b);
  }, (0, _immutable.OrderedMap)());
};

var _default = formatPipelineStages;
exports.default = _default;
module.exports = exports.default;